import {
  zLabWorkbookAssignmentOptionsResponse,
  type LabWorkbookAssignmentOptionsResponse,
} from '@resistapp/common/api-types';
import { useQuery } from '@tanstack/react-query';

import { getAuthHeaders, resistomapApiClient } from '../../../utils/fetch';

async function fetchLabAssignmentOptions(workbookId: string): Promise<LabWorkbookAssignmentOptionsResponse> {
  const response = await resistomapApiClient.get<LabWorkbookAssignmentOptionsResponse>(
    `/lab-workbook/${workbookId}/assignment-options`,
    { headers: getAuthHeaders('application/json') },
  );
  return zLabWorkbookAssignmentOptionsResponse.parse(response.data);
}

type UseLabAssignmentOptionsOptions = {
  enabled?: boolean;
};

export function useLabAssignmentOptions(workbookId: string | null, options?: UseLabAssignmentOptionsOptions) {
  const enabled = Boolean(workbookId) && (options?.enabled ?? true);
  return useQuery({
    queryKey: ['labAssignmentOptions', workbookId],
    enabled,
    queryFn: async () => {
      if (!workbookId) {
        throw new Error('Missing workbook identifier');
      }
      return await fetchLabAssignmentOptions(workbookId);
    },
    staleTime: 30_000,
  });
}
